var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"v-btn",class:_vm.classes,attrs:{"disabled":_vm.disabled,"autofocus":_vm.autofocus,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.$slots.icon)?_vm._t("icon"):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('span',{staticClass:"v-btn__content"},[_vm._t("default")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }